import React, { useState, useRef, useEffect } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Text,
  Box,
} from "@chakra-ui/react";
import { TbEdit, TbTrashX, TbDotsVertical } from "react-icons/tb";
import {
  textSecondary,
  white,
  newBorder,
  primary,
  primaryAlt,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { TbCheckbox, TbEye } from "react-icons/tb";
import useThemeColors from "../../hooks/useThemeColors";

const MoreButtonLite = React.forwardRef(
  (
    {
      deleteHandler,
      deleteLabel,
      isBig,
      isSmall,
      viewHandler,
      viewLabel,
      viewId,
      viewIcon,
      editHandler,
      editLabel,
      editIcon,
      editId,
      editButtonDisabled,
      deleteButtonDisabled,
      isDisabled,
      setShowDeleteConfirmation,
      h,
      w,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation();
    const { backgroundLightMode } = useThemeColors();

    const [isOpen, setIsOpen] = useState(false);

    const btnRef2 = useRef();

    const handleClickOutside = (event) => {
      if (btnRef2.current && !btnRef2.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleDeleteConfirmation = () => {
      setShowDeleteConfirmation(true);
      setIsOpen(false); // Close the menu after clicking "Delete"
    };

    const handleOpenPatient = () => {
      viewHandler(viewId);
      setIsOpen(false); // Close the menu after clicking "Delete"
    };

    const handleEdit = () => {
      // console.log("editId", editId);
      editHandler(editId);
      setIsOpen(false); // Close the menu after clicking "Delete"
    };

    // console.log("isDisabled", isDisabled);

    return (
      <Box ref={ref} p={0} borderRadius="0.75rem" ml={2}>
        <Menu isLazy isDisabled={true}>
          <MenuButton
            {...props}
            type="button"
            bg={backgroundLightMode}
            color={textSecondary}
            border={`1px solid ${backgroundLightMode}`}
            display="flex"
            alignItems="center"
            fontSize="sm"
            justifyContent="center"
            h={h ? h : "2.5rem"}
            w={w ? w : "2.5rem"}
            borderRadius={isSmall ? "10.5rem" : "10.75rem"}
            p={0}
            m="0"
            transition="0.2s all"
            _hover={{
              bg: primaryAlt,
              color: white,
              border: `1px solid ${primaryAlt}`,
            }}
            _disabled={{
              opacity: 0.4,
              cursor: "not-allowed",
              bg: white,
              color: textSecondary,
            }}
            disabled={isDisabled}
          >
            <Icon
              as={TbDotsVertical}
              h={isBig ? "1.25rem" : isSmall ? "1rem" : "1.125rem"}
              w={isBig ? "1.25rem" : isSmall ? "1rem" : "1.125rem"}
              bg="none"
              mt={1}
              p={0}
            />
          </MenuButton>
          <MenuList p={0} m={0} borderRadius="1rem" overflow="hidden">
            {viewHandler && (
              <MenuItem
                py={4}
                px={4}
                color={textSecondary}
                transition="0.2s all"
                borderBottom={`1px solid ${newBorder}`}
                _hover={{ bg: primary, color: white }}
                onClick={handleOpenPatient}
              >
                <Icon
                  as={viewIcon || TbEye}
                  mr="0.5rem"
                  h="1rem"
                  w="1rem"
                  style={{
                    pointerEvents: "none",
                  }}
                />
                <Text
                  fontSize="0.875rem"
                  fontWeight="500"
                  lineHeight="1"
                  style={{
                    pointerEvents: "none",
                  }}
                >
                  {viewLabel || t("button.view")}
                </Text>
              </MenuItem>
            )}

            {editHandler && (
              <MenuItem
                py={4}
                px={4}
                color={textSecondary}
                transition="0.2s all"
                borderBottom={`1px solid ${newBorder}`}
                _hover={{ bg: primary, color: white }}
                onClick={handleEdit}
                isDisabled={editButtonDisabled}
              >
                <Icon
                  as={editIcon || TbEdit}
                  mr="0.5rem"
                  h="1rem"
                  w="1rem"
                  style={{
                    pointerEvents: "none",
                  }}
                />
                <Text
                  fontSize="0.875rem"
                  fontWeight="500"
                  lineHeight="1"
                  style={{
                    pointerEvents: "none",
                  }}
                >
                  {editLabel || t("button.edit")}
                </Text>
              </MenuItem>
            )}

            {deleteHandler && (
              <MenuItem
                py={4}
                px={4}
                color={textSecondary}
                transition="0.2s all"
                borderBottom={`1px solid ${newBorder}`}
                _hover={{ bg: primary, color: white }}
                onClick={handleDeleteConfirmation}
                isDisabled={deleteButtonDisabled}
              >
                <Icon
                  as={TbTrashX}
                  mr="0.5rem"
                  h="1rem"
                  w="1rem"
                  style={{
                    pointerEvents: "none",
                  }}
                />
                <Text
                  fontSize="0.875rem"
                  fontWeight="500"
                  lineHeight="1"
                  style={{
                    pointerEvents: "none",
                  }}
                >
                  {deleteLabel || t("button.delete")}
                </Text>
              </MenuItem>
            )}
          </MenuList>
        </Menu>
      </Box>
    );
  }
);

export default MoreButtonLite;
